export type OrderArtifact = 'OTU_FASTA' | 'PROCESSING_SUMMARY' | 'MULTIQC'

/** `label` is the customer-facing artifact name for messages, deliberately not the button text. */
export const orderArtifactDescriptors: Record<OrderArtifact, { path: string; label: string }> = {
  OTU_FASTA: { path: 'otufile', label: 'OTU.fasta' },
  PROCESSING_SUMMARY: { path: 'processing-summary', label: 'Summary PDF' },
  MULTIQC: { path: 'multiqc', label: 'MultiQC report' }
}
